import { orchestrator } from 'satcheljs';
import { logInlineFeedbackDialogResponse } from '../actions/logInlineFeedbackDialogResponse';
import { CaptureFeedbackDatapoint } from 'owa-feedback-common';

export default orchestrator(logInlineFeedbackDialogResponse, async dialogResponse => {
    const keys: string[] = ['fdsid', 'fdt', 'fdc', 'fdicd', 'fduvt', 'fdodsr'];

    let values: string[] = [
        dialogResponse.sessionId,
        dialogResponse.inlineFeedbackResponseText,
        dialogResponse.inlineFeedbackResponseCategories.join(' | '),
        dialogResponse.isContentDonated ? 'Yes' : 'No',
        dialogResponse.isUVTicketCreated ? 'Yes' : 'No',
        dialogResponse.odsResponse,
    ];

    await CaptureFeedbackDatapoint.import().then(captureFeedbackDatapoint => {
        captureFeedbackDatapoint({
            keys: keys,
            values: values,
        });
    });
});
